import React, { useState } from "react";
import { Menu, MenuItem, ListItemIcon, ListItemText } from "@mui/material";
import { MoreVert } from "@mui/icons-material";
import { Globe, Trash2, Pencil } from "lucide-react";
import { tr } from "../../../i18n";

function Url({ data, addSchedule, deleteSingleContent, editContent, readOnly = false }) {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  return (
    <div className="ct-content-card" key={data.key || data.id}>
      <div className="ct-content-card-preview ct-content-card-preview--url">
        <div className="ct-content-card-icon-wrap">
          <Globe size={28} />
        </div>
        <span className="ct-content-card-placeholder-label">{tr("Web page")}</span>
        <div className="ct-content-card-badge">
          <Globe size={10} />
          <span>{tr("URL")}</span>
        </div>
        {!readOnly && (
          <button
            type="button"
            className="ct-content-card-menu-btn"
            onClick={(e) => {
              e.stopPropagation();
              setAnchorEl(e.currentTarget);
            }}
            aria-label={tr("Menu")}
          >
            <MoreVert sx={{ fontSize: 16 }} />
          </button>
        )}
        {!readOnly && (
        <Menu
          anchorEl={anchorEl}
          open={open}
          onClose={() => setAnchorEl(null)}
          onClick={() => setAnchorEl(null)}
          PaperProps={{
            sx: {
              borderRadius: "8px",
              minWidth: "140px",
              boxShadow: "0 4px 16px rgba(0,0,0,.1)",
            },
          }}
        >
          <MenuItem
            onClick={() => editContent(data)}
            sx={{
              fontFamily: "'Electrolize', sans-serif",
              fontSize: "13px",
              gap: "8px",
            }}
          >
            <ListItemIcon sx={{ minWidth: "24px !important" }}>
              <Pencil size={14} color="#4a5568" />
            </ListItemIcon>
            <ListItemText
              primaryTypographyProps={{
                fontFamily: "'Electrolize', sans-serif",
                fontSize: "13px",
              }}
            >
              {tr("Edit")}
            </ListItemText>
          </MenuItem>
          <MenuItem
            onClick={() => deleteSingleContent(data.id)}
            sx={{
              fontFamily: "'Electrolize', sans-serif",
              fontSize: "13px",
              gap: "8px",
              color: "#e53e3e",
            }}
          >
            <ListItemIcon sx={{ minWidth: "24px !important" }}>
              <Trash2 size={14} color="#e53e3e" />
            </ListItemIcon>
            <ListItemText
              primaryTypographyProps={{
                fontFamily: "'Electrolize', sans-serif",
                fontSize: "13px",
                color: "#e53e3e",
              }}
            >
              {tr("Delete")}
            </ListItemText>
          </MenuItem>
        </Menu>
        )}
      </div>
      <div className="ct-content-card-footer">
        <span className="ct-content-card-name">
          {data.name?.substring(0, 24) || tr("Untitled")}
        </span>
        <span className="ct-content-card-type">
          <Globe size={12} />
          {tr("URL")}
        </span>
      </div>
    </div>
  );
}

export default Url;
